import React, { useRef, useEffect, useLayoutEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useRouteMatch } from 'react-router-dom';
import { getNavbarHeight, getViewportDimensions } from '../../../../models/Utils';
import { ADALandmarks, ADAARIARoles, ADAWidgitRoles } from '../../../../models/ADA';

import './TopicElement.scss';

const TopicElement = React.forwardRef(({ topic, bubbleLabels, mainBubbleSize, isTopicSelected, isVisible, redirectHandler, onMobile }, theRef) => {
  const mediaPath = useSelector(state => state.config.basePath + state.config.apiMediaPath);
  const [isActive, setIsActive] = useState(false);
  const refIsVisible = useRef(false);
  const refOnMobile = useRef(false);
  const refMidLine = useRef(null);
  const refViewportDims = useRef(null);
  const { path, url } = useRouteMatch();

  useEffect(() => {
    refIsVisible.current = isVisible;
    refOnMobile.current = onMobile;
    if (isVisible) handleScroll();
  }, [isVisible, onMobile]);

  const handleScroll = () => {
    if (!refIsVisible.current) return;

    
    if (!refViewportDims.current || refViewportDims.current.onMobile !== refOnMobile.current) {
      refViewportDims.current = {
        onMobile: refOnMobile.current,
        navbarHeight: getNavbarHeight(),
        ...getViewportDimensions()
      };
    }
    if (refOnMobile.current) {
      const elementRect = refMidLine.current.parentNode.getBoundingClientRect();
      if (elementRect.top < refViewportDims.current.navbarHeight + (refViewportDims.current.height - refViewportDims.current.navbarHeight) * 0.5 && elementRect.top + elementRect.height > refViewportDims.current.navbarHeight + (refViewportDims.current.height - refViewportDims.current.navbarHeight) * 0.5) {
        setIsActive(true);
      } else {
        setIsActive(false);
      }
    } else {
      const centerRect = refMidLine.current.getBoundingClientRect();
      if (centerRect.top > refViewportDims.current.navbarHeight + (refViewportDims.current.height - refViewportDims.current.navbarHeight) * 0.25 && centerRect.top < refViewportDims.current.navbarHeight + (refViewportDims.current.height - refViewportDims.current.navbarHeight) * 0.75) {
        setIsActive(true);
      } else {
        setIsActive(false);
      }
    }
  };

  const initiateRedirect = (event, to) => {
    event.preventDefault();

    const element = event.target;

    //element.classList.add('ripple');
    redirectHandler(to);

    //setTimeout(() => {
      
      //element.classList.add('post-ripple');
      //setTimeout(() => {
      //  if (element && element.classList) element.classList.remove('ripple', 'post-ripple');
      // }, 400);
    //}, 400);
  };

  useLayoutEffect(() => {
    handleScroll();

    document.body.addEventListener('scroll', handleScroll);

    return () => {
      document.body.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div 
      className={`innovation-topic-element ${ isActive ? 'active' : '' }`}
      ref={theRef}
    >
      <div className="innovation-te-center" ref={refMidLine} role={ADAARIARoles.Group}>
        <div className="innovation-te-dynamic-element innovation-te-back-line"/>
        


        <div
          className="innovation-te-dynamic-element innovation-te-main-bubble innovation-te-overview"
          style={{
            width: `${mainBubbleSize}px`,
            height: `${mainBubbleSize}px`,
            zIndex:10
          }}
          // onMouseEnter={() => setIsActive(true)}
          // onMouseLeave={() => setIsActive(false)}
        >
          <div
            className="innovation-te-de-bgnd"
            style={{
              backgroundImage: `url(${ mediaPath + topic.Overview.BubbleImage})`
            }}
          />
          <div className="innovation-te-mb-title" aria-hidden={true}>{topic.Title}</div>
          {/* <Link aria-hidden={true} className="innovation-te-button-link" to={`${url}/${topic.Path.Text}`}/> */}
          <button role={ADAWidgitRoles.Button} aria-label={topic.Title}  tabIndex={isTopicSelected?-1:0}
           href={`${url}/${topic.Path.Text}`} className="innovation-te-button-link" onClick={(ev) => initiateRedirect(ev, `${url}/${topic.Path.Text}`)}/>
        </div>



        <div
          className={`innovation-te-dynamic-element innovation-te-side-bubble innovation-te-prev ${onMobile ? '' : 'innovation-te-de-hidden'}`}
        >
          <div
            className="innovation-te-de-bgnd"
            style={{
              backgroundImage: `url(${ mediaPath + topic.Origin.BubbleImage })`
            }}
          >
            <div className="innovation-te-de-bgnd-overlay prev"/>
          </div>
          {/* <Link aria-hidden={true} className="innovation-te-button-link" to={`${url}/${topic.Path.Text}`}/> */}
          <button role={ADAWidgitRoles.Button} aria-label={topic.Title} tabIndex={isTopicSelected?-1:0}
           href={`${url}/${topic.Path.Text}`} className="innovation-te-button-link" onClick={(ev) => initiateRedirect(ev, `${url}/${topic.Path.Text}`)}/>
        </div>



        <div
          className={`innovation-te-dynamic-element innovation-te-side-bubble innovation-te-next ${onMobile ? '' : 'innovation-te-de-hidden'}`}
        >
          <div
            className="innovation-te-de-bgnd"
            style={{
              backgroundImage: `url(${ mediaPath + topic.Future.BubbleImage })`
            }}
          >
            <div className="innovation-te-de-bgnd-overlay next"/>
          </div>
          {/* <Link aria-hidden={true} className="innovation-te-button-link" to={`${url}/${topic.Path.Text}`}/> */}
          <button role={ADAWidgitRoles.Button} aria-label={topic.Path.Text} tabIndex={isTopicSelected?-1:0} 
          href={`${url}/${topic.Path.Text}`} className="innovation-te-button-link" onClick={(ev) => initiateRedirect(ev, `${url}/${topic.Path.Text}`)}/>
        </div>



        <div
          className={`innovation-te-dynamic-element innovation-te-side-bubble innovation-te-origin ${onMobile ? 'innovation-te-de-hidden' : ''}`}
        >
          <div
            className="innovation-te-de-bgnd"
            style={{
              backgroundImage: `url(${ mediaPath + topic.Origin.BubbleImage })`
            }}
          >
            <div className="innovation-te-de-bgnd-overlay origin"/>
          </div>
          <div aria-hidden={true} className="innovation-te-sb-title">{bubbleLabels.Origin}</div>
          {/* <Link aria-hidden={true} className="innovation-te-button-link" to={`${url}/${topic.Path.Text}#${bubbleLabels.Origin}`}/> */}
          <button role={ADAWidgitRoles.Button} aria-label={bubbleLabels.Origin} tabIndex={isTopicSelected?-1:0}
           href={`${url}/${topic.Path.Text}#${bubbleLabels.Origin}`} className="innovation-te-button-link" onClick={(ev) => initiateRedirect(ev, `${url}/${topic.Path.Text}#${bubbleLabels.Origin}`)}/>
        </div>



        <div
          className={`innovation-te-dynamic-element innovation-te-side-bubble innovation-te-context ${onMobile ? 'innovation-te-de-hidden' : ''}`}
        >
          <div
            className="innovation-te-de-bgnd"
            style={{
              backgroundImage: `url(${ mediaPath + topic.Context.BubbleImage })`
            }}
          >
            <div className="innovation-te-de-bgnd-overlay context"/>
          </div>
          <div aria-hidden={true} className="innovation-te-sb-title">{bubbleLabels.Context}</div>
          {/* <Link aria-hidden={true} className="innovation-te-button-link" to={`${url}/${topic.Path.Text}#${bubbleLabels.Context}`}/> */}
          <button role={ADAWidgitRoles.Button} aria-label={bubbleLabels.Context} tabIndex={isTopicSelected?-1:0}
           href={`${url}/${topic.Path.Text}#${bubbleLabels.Context}`} className="innovation-te-button-link" onClick={(ev) => initiateRedirect(ev, `${url}/${topic.Path.Text}#${bubbleLabels.Context}`)}/>
        </div>



        <div
          className={`innovation-te-dynamic-element innovation-te-side-bubble innovation-te-impact ${onMobile ? 'innovation-te-de-hidden' : ''}`}
        >
          <div
            className="innovation-te-de-bgnd"
            style={{
              backgroundImage: `url(${ mediaPath + topic.Impact.BubbleImage })`
            }}
          >
            <div className="innovation-te-de-bgnd-overlay impact"/>
          </div>
          <div aria-hidden={true} className="innovation-te-sb-title">{bubbleLabels.Impact}</div>
          {/* <Link aria-hidden={true} className="innovation-te-button-link" to={`${url}/${topic.Path.Text}#${bubbleLabels.Impact}`}/> */}
          <button role={ADAWidgitRoles.Button} aria-label={bubbleLabels.Impact} tabIndex={isTopicSelected?-1:0}
           href={`${url}/${topic.Path.Text}#${bubbleLabels.Impact}`} className="innovation-te-button-link" onClick={(ev) => initiateRedirect(ev, `${url}/${topic.Path.Text}#${bubbleLabels.Impact}`)}/>
        </div>



        <div
          className={`innovation-te-dynamic-element innovation-te-side-bubble innovation-te-future ${onMobile ? 'innovation-te-de-hidden' : ''}`}
        >
          <div
            className="innovation-te-de-bgnd"
            style={{
              backgroundImage: `url(${ mediaPath + topic.Future.BubbleImage })`
            }}
          >
            <div className="innovation-te-de-bgnd-overlay future"/>
          </div>
          <div aria-hidden={true} className="innovation-te-sb-title">{bubbleLabels.Future}</div>
          {/* <Link aria-hidden={true} className="innovation-te-button-link" to={`${url}/${topic.Path.Text}#${bubbleLabels.Future}`}/> */}
          <button role={ADAWidgitRoles.Button} aria-label={bubbleLabels.Future} tabIndex={isTopicSelected?-1:0}
          href={`${url}/${topic.Path.Text}#${bubbleLabels.Future}`} className="innovation-te-button-link" onClick={(ev) => initiateRedirect(ev, `${url}/${topic.Path.Text}#${bubbleLabels.Future}`)}/>
        </div>



      </div>
    </div>
  );
});

export default TopicElement;